import { marked } from "marked";
import { init, init1, audio, getWeather } from "@/api/index";
import { fetchEventSource } from "@microsoft/fetch-event-source";

import video from "@/assets/video/idel2.webm";
import video2 from "@/assets/video/2.webm";
import audios from "@/assets/video/11.wav";
import audio1 from "@/assets/video/1.wav";
import audio2 from "@/assets/video/2.wav";
import audio3 from "@/assets/video/3.wav";
import audio4 from "@/assets/video/4.wav";
import audio5 from "@/assets/video/5.wav";
import audio6 from "@/assets/video/6.wav";
import audio7 from "@/assets/video/7.wav";
import audio8 from "@/assets/video/8.wav";
// import IatRecorder from '@/assets/js/IatRecorder.js'
// const iatRecorder = new IatRecorder({

// })

let websocketWS;
export default {
  data() {
    return {
      srcList: [],
      curIndex: 0,
      playVideoTag: true, // 当前播放的 ref 是否为 video
      canPlayNext: true, // 是否存在下一个播放地址
      audioObj: null,
      flags: false,
      plays: null,
      countdown: 30,
      timer: null,
      // headerText: "",
      // bottomText: "。 回复内尽量精简，不超过100个字。",
      videoSrc: video,
      controller: null,
      str: "",
      videos: false,
      playsFlag: false,
      playTimers: null,
      // videoSrcs: [],
      todayName: "星期一",
      // dataName: "",
      recordingPermission: false,
      timers:null,//记录当前是否有点击确定
    };
  },
  computed: {
    markdownToHtml() {
      return marked(this.message);
    },
    nr() {
      return function (val) {
        return marked(val);
      };
    },
  },
  mounted() {
    this.audioObj = new Audio();
    console.log("##", "播放器创建", this.audioObj);
    // this.getDate();
    // this.headerText =
    //   "今天是" +
    //   this.dataName +
    //   "，" +
    //   this.todayName +
    //   "，天气晴。中山市委网信办全称是中共中山市委网络安全和信息化委员会办公室，负责统筹指导全市网络安全和信息化工作开展,也是这次网络安全体验展的主办方哦。网络安全为人民，网络安全靠人民。欢迎来到中山市网络安全体验展，本次体验展是由广东省委网信办统一部署，中市委网信办创新谋划打造，旨在深入宣传展示网络安全科普知识，向全市广大市民群众提供一个沉浸式学习体验场景。我是讲解员“小布哥”，我能为大家个绍体验展的相关情况，告诉大家哪里可以学到最实用的网络安全小知识、哪里可以体验到有趣的人工智能新技术。同时，我也是一位网络安全小专家哦，期待能与大家一同分享和学习更多网络安全知识。网络安全体验区 第二个分区是“网络安全发展脉络区”，这里系统展示互联网从诞生到现在的发展历程，包括重要的技术突破和网络发展标志性事件。在这里，您可以了解到网络安全从无到有、从简单到复杂、从单一到多维的发展趋势。第三个分区是“数据安全和个人信息保护区”。这个区域将介绍如何做好个人信息安全保护、防止数据泄露等。通过各种场景演示和实例宣传，在体验中提高个人信息自我保护的意识和能力。第四个分区是“物联网技术互动区”。这里将会通过有趣的互动展示与联网与物联网等技术如何推动和影响我们的工作生活，同时也引发我们对技术应用可能带来潜在网络安全威胁的思考。第五个分区是“新技术体验区”。在这里您将接触到包括人工智能、VR、AR等前沿技术，您可以与人工智能进行文本对话交互，也可以感受虚拟现实的视觉体验，还可以参观网络安全AI主题画展。第六个分区是“网络文明专区”。这个区域包括对网络文明理念的宣传、对网络文明知识的普及，提醒我们要养成良好上网习惯，共同营造良好的网络环境。第七个分区是“反诈宣传专区”，这里将会通过各种案例和宣传互动，让您识破各种网络诈骗手段，不断提高我们的网络反诈意识。以上是本次网络安全体验展的基本内容，期待您在这次体验展中收获对网络安全更多更深入的知识，愿大家共建共享和谐网络空间，齐心推动互联网技术不断造福于我们的生活。假如你现在是展会讲解员，如果上文中有相关内容，请根据内容讲解。 不要出现“根据提供的信息”的相关字眼。问题如下：";
    // this.getWeather()
  },
  methods: {
    onEnded(e) {
      if (this.canPlayNext) {
        const video = e === "video" ? this.$refs.video1 : this.$refs.video;
        video.play();
        this.playVideoTag = !this.playVideoTag;
        this.loadNext();
      }
      console.log("onended my video");
      this.$emit("ended");
    },
    playVideo(src) {
      // 可以接受单个 url 和 url 列表
      this.srcList = typeof src === "string" ? [src] : src;
      this.$refs.video.src = src[0];
      this.$refs.video.addEventListener(
        "canplay",
        () => {
          this.canPlayNext = true;
          // this.$refs.videoBox.style.zIndex='-1'
        },
        {
          once: true,
        }
      );
      this.srcList = src;
      this.loadNext();
    },
    loadNext() {
      const video = this.playVideoTag ? this.$refs.video1 : this.$refs.video;
      if (this.srcList.length - 1 === this.curIndex) {
        // 当前索引是列表的最后一个
        console.log("没有新视频");
        // this.canPlayNext = false
        
        return;
      }
      video.src = this.srcList[++this.curIndex];
      video.addEventListener("canplay", (e) => e.target.pause(), {
        once: true,
      });
    },
    async getWeather() {
      // const res=await getWeather(101281701)
      // console.log(res,'resss');
    },
    formDate() {
      var now = new Date();
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().padStart(2, "0");
      var day = now.getDate().toString().padStart(2, "0");
      var hours = now.getHours().toString().padStart(2, "0");
      var minutes = now.getMinutes().toString().padStart(2, "0");
      var seconds = now.getSeconds().toString().padStart(2, "0");

      var formattedNow =
        year +
        "年" +
        month +
        "月" +
        day +
        "日 " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;

      let dayOfWeek = now.getDay();
      let daysOfWeek = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      this.todayName = daysOfWeek[dayOfWeek];

      return formattedNow;
    },
    getDate() {
      let today = new Date();

      let month = today.getMonth() + 1;
      let dayOfWeek = today.getDay();
      let daysOfWeek = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      // this.todayName = daysOfWeek[dayOfWeek];
      let day = today.getDate();

      // this.dataName = month + "月" + day + "日";
    },
    searchKeys(arr) {
      var str = "";
      var list = [];
      for (var i = 0; i < arr.length; i++) {
        var hasRead = false;
        for (var k = 0; k < list.length; k++) {
          if (list[k].role == arr[i].role) {
            hasRead = true;
          }
        }
        if (!hasRead) {
          var _index = i,
            haveSame = false;
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].role == arr[j].role) {
              _index += "," + j;
              haveSame = true;
            }
          }
          if (haveSame) {
            // list.push(arr[i].role);
            str = "数组下标为" + _index + "，相同值为" + arr[i].role + "\n";
          }
        }
      }
      return str;
    },

    //  truncateString(str, maxLength) {
    //   if (str.length <= maxLength) {
    //     return str;
    //   }
    //   var subString = str.substr(0, str.length);
    //   var punctuationIndex = -1;
    //   for (var i = maxLength; i <=str.length; i++) {
    //     if (str[i] === "." || str[i] === "。"|| str[i] === "," || str[i] === "!" || str[i] === "?") {
    //       punctuationIndex = i;
    //       console.log(11);
    //       break;
    //     }
    //   }
    //   if (punctuationIndex !== -1) {
    //     subString = subString.substr(0, punctuationIndex + 1);
    //   }
    //   return subString;
    // },
    //帮助
    help() {
      this.maskFlag = true;
      try {
        if (this.signSucc) {
          if (this.plays) {
            this.plays.then((res) => {
              this.signSucc.pause();
            });
          }
        }
      } catch (error) {
        console.log(error, "error");
      }
    },
    okBtn() {
      this.maskFlag = false;
    },

    //询问
    ask() {
      if(this.flags) return
      this.controller && this.controller.abort();
      this.$refs.videoBox.style.zIndex = "-1";
      this.$refs.video.src = "";
      this.$refs.video1.src = "";
      try {
        this.signSucc && this.signSucc?.pause()
        this.plays = null
        this.signSucc = ''
        

        // if (this.signSucc) {
        //   if (this.plays) {
        //     this.plays.then((res) => {
        //       this.signSucc.pause();
        //     });
        //   }
        // }
      } catch (e) {
        console.error('暂停音频失败',e);
      }
      this.flags = true;
      clearInterval(this.playTimers);
      this.timer = null;
      this.countdown = 30;
      this.content = "";
      this.videos = false;
      // iatRecorder.start()
      this.flag = true;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown == 0) {
          clearInterval(this.timer);
          this.flags = false;
        }
      }, 1000);
      if (this.recordingPermission) {
        console.log(this.countdown, "this.countdown");

        this.recStart();
      } else {
        console.log(8888888888);
        this.isRecOpen();
      }
    },
    isRecOpen() {
      console.log(777);
      this.recOpen()
        .then((res) => {
          if (res.code) {
            this.recordingPermission = true;
            this.recStart();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    cancelBtn() {
      this.flags = false;

      this.content = "";
      this.countdown = 0;
      console.log("清空timer", this.timer);
      clearInterval(this.timer);
      this.recStop();
      this.videoSrc = video;
    },
    //确定
    confirmBtn() {
      if(this.timers) return
      clearTimeout(this.speechInputTimeout);
      this.speechInputTimeout = null;
      
      // this.flag = false;
      console.log("清空timer", this.timer);
      this.countdown = 0;
      this.flags = false;
      self.stop();
      this.counterDownTime = 0;
      clearTimeout(this.counterDownTimeout);

      // self.reset()
      this.recStop();
      clearInterval(this.timer);
      if (!this.content) {
        this.flag = false;
        return;
      }
      this.isShow = true;
      this.timers = setTimeout(()=>{
        clearTimeout(this.timers)
        this.timers = null
      },2000)
      this.source();
      // this.flags = true;
      // this.source();
    },
    //清除记录
    clearHistory() {
      if(!this.signSucc.src || this.signSucc.paused){
        // setTimeout(()=>{
        //   if(!this.signSucc.src || this.signSucc.paused){
        //     this.prompt = [];
        //   }
        // },500)
        this.prompt = [];
      }
      else {
        this.prompt.splice(0, this.prompt.length - 1);
      }

      
      // this.controller && this.controller.abort();
      // this.prompt = [];
      // this.$refs.videoBox.style.zIndex = "-1";
      // this.$refs.video.src = "";
      // this.$refs.video1.src = "";
      // try {
      //   this.signSucc && this.signSucc?.pause()
      //   this.plays = null
      //   this.signSucc = ''
      // } catch (e) {
      //   console.error('暂停音频失败',e);
      // }
    },
    //取消
    paused() {
      if (this.signSucc) {
        if (this.plays) {
          this.plays.then((res) => {
            this.signSucc.pause();
            this.videoSrc = video;
          });
        }
      }

      // this.flags = false;
    },

    //流式输出
    source() {
      let that = this;
      this.srcList = [];
      this.curIndex = 0;
      this.playVideoTag = true; // 当前播放的 ref 是否为 video
      this.canPlayNext = true; // 是否存在下一个播放地址
      that.message = "";
      const pattern = /\[.*?\]/;
      if (pattern.test(that.message)) {
        that.prompt.splice(0, that.prompt.length - 2);
      }
     this.$nextTick(()=>{
      let container =
      document.querySelector(".rowy") || document.querySelector(".main");
    setTimeout(() => {
      container.scrollTop = container.scrollHeight;
    });
     })

      that.prompt.push({
        role: "user",
        // content:that.headerText+
        //   that.content +
        //  that.bottomText,
        content: that.content,
        //知识点：现在日期和时间是 ${formDate()}，今天${todayName}，今天天气：${weatherData.wea}，温度：${weatherData.weather}。我的问题是："${message}"
        // content:`知识点：现在日期和时间是 ${that.formDate()}，今天${that.todayName}。我的问题是："${that.content}"`
      });
      // that.prompt.push({
      //   role: "user",
      //   content:'网络安全为人民，网络安全靠人民。欢迎来到中山市网络安全体验展，本次体验展是由广东省委网信办统一部署，中市委网信办创新谋划打造，旨在深入宣传展示网络安全科普知识，向全市广大市民群众提供一个沉浸式学习体验场景。我是讲解员“小布哥”，我能为大家个绍体验展的相关情况，告诉大家哪里可以学到最实用的网络安全小知识、哪里可以体验到有趣的人工智能新技术。同时，我也是一位网络安全小专家哦，期待能与大家一同分享和学习更多网络安全知识。网络安全体验区 第二个分区是“网络安全发展脉络区”，这里系统展示互联网从诞生到现在的发展历程，包括重要的技术突破和网络发展标志性事件。在这里，您可以了解到网络安全从无到有、从简单到复杂、从单一到多维的发展趋势。第三个分区是“数据安全和个人信息保护区”。这个区域将介绍如何做好个人信息安全保护、防止数据泄露等。通过各种场景演示和实例宣传，在体验中提高个人信息自我保护的意识和能力。第四个分区是“物联网技术互动区”。这里将会通过有趣的互动展示与联网与物联网等技术如何推动和影响我们的工作生活，同时也引发我们对技术应用可能带来潜在网络安全威胁的思考。第五个分区是“新技术体验区”。在这里您将接触到包括人工智能、VR、AR等前沿技术，您可以与人工智能进行文本对话交互，也可以感受虚拟现实的视觉体验，还可以参观网络安全AI主题画展。第六个分区是“网络文明专区”。这个区域包括对网络文明理念的宣传、对网络文明知识的普及，提醒我们要养成良好上网习惯，共同营造良好的网络环境。第七个分区是“反诈宣传专区”，这里将会通过各种案例和宣传互动，让您识破各种网络诈骗手段，不断提高我们的网络反诈意识。以上是本次网络安全体验展的基本内容，期待您在这次体验展中收获对网络安全更多更深入的知识，愿大家共建共享和谐网络空间，齐心推动互联网技术不断造福于我们的生活。假如你现在是展会讲解员，如果上文中有相关内容，请根据内容讲解。 不要出现“根据提供的信息”的相关字眼。问题如下：'+
      //     that.content +
      //     '。 回复内尽量精简，不超过60个字。',
      // });
      const OPENAI_API_KEY = "eyJhbGciOiJIUzI1NiIsInNpZ25fdHlwZSI6IlNJR04ifQ.eyJhcGlfa2V5IjoiZDljOTRiODQ0OWRkYzEyZjY0ZGU3NDc4Njk0NTNjOTkiLCJleHAiOiIxNzYzNDI4ODA0NzUzIiwidGltZXN0YW1wIjoiMTczMTg5MjgwNDc1MyJ9.FPqvo5AJUHRUyvIvrUDhja3wXDUYP5MDV5qkSoXQBH0"
      const OPENAI_API_KEY1 =
        "eyJhbGciOiJIUzI1NiIsInNpZ25fdHlwZSI6IlNJR04iLCJ0eXAiOiJKV1QifQ.eyJhcGlfa2V5IjoiZDljOTRiODQ0OWRkYzEyZjY0ZGU3NDc4Njk0NTNjOTkiLCJleHAiOjE2OTczMzA1NTcwOTYsInRpbWVzdGFtcCI6MTY5MTk3Mzc1NzA5Nn0.TmsYUHVYGR8slGadI7QqJ53kEa2X4H2xIm5kicGCNoY";
      // const OPENAI_API_KEY =
      //   "eyJhbGciOiJIUzI1NiIsInNpZ25fdHlwZSI6IlNJR04iLCJ0eXAiOiJKV1QifQ.eyJhcGlfa2V5IjoiZDljOTRiODQ0OWRkYzEyZjY0ZGU3NDc4Njk0NTNjOTkiLCJleHAiOjE3Mjc0MTkzNDI0MDksInRpbWVzdGFtcCI6MTY5NTI3ODU0MjQwOX0.YH_865ctnHKsH2DbsFpO1aLxGmYvf-rHBQYzYkDOgyA";
      const OPENAI_COMPLETION_ENDPOINT =
        "https://open.bigmodel.cn/api/llm-application/open/model-api/1774996272051376129/sse-invoke";
      var request_data = [];
      request_data[0] = that.prompt[that.prompt.length - 1];
      const requestData = {
        // prompt: request_data,
        prompt: [
          {
            role: "user",
            // content:that.headerText+
            //   that.content +
            //  that.bottomText,
            // content: that.content,
            //知识点：现在日期和时间是 ${formDate()}，今天${todayName}，今天天气：${weatherData.wea}，温度：${weatherData.weather}。我的问题是："${message}"
            content: `知识点：现在日期和时间是 ${that.formDate()}，今天${
              that.todayName
            }。我的问题是："${that.content}"`,
          },
        ],
      };
      that.controller = new AbortController();
      fetchEventSource(OPENAI_COMPLETION_ENDPOINT, {
        signal: that.controller.signal,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${OPENAI_API_KEY}`,
        },
        body: JSON.stringify(requestData),
        async onopen(response) {
          try {
            that.signSucc = that.audioObj;

            var voice_path = "";
            switch (parseInt(((Math.random() * 10) % 8) + 1)) {
              case 1:
                voice_path = audio1;
                break;
              case 2:
                voice_path = audio2;
                break;
              case 3:
                voice_path = audio3;
                break;
              case 4:
                voice_path = audio4;
                break;
              case 5:
                voice_path = audio5;
                break;
              case 6:
                voice_path = audio6;
                break;
              case 7:
                voice_path = audio7;
                break;
              case 8:
                voice_path = audio8;
                break;
            }

            that.signSucc.src = voice_path;
            that.plays = that.signSucc.play();
            that.signSucc.addEventListener("ended", function () {
              that.playsFlag = true;
            });
          } catch (error) {}
          // console.log("##", "流式开始", that.flags);
          console.log(response, "response");
          if (
            response.ok &&
            response.headers.get("content-type") === "text/event-stream"
          ) {
          } else if (
            response.status >= 400 &&
            response.status < 500 &&
            response.status !== 429
          ) {
            console.log("请求错误");
          } else {
            console.log("其他错误");
          }
        },
        onmessage(msg) {
          // that.isShow=false
          console.log("##", "GLM语言模型", msg);
          that.content = "";
          console.log(that.message, "that.message");
          that.message = msg.data;
          // if(that.message.length<=60){
          //   that.message += msg.data;
          //   console.log('jiesu','zhang',that.message);
          // }else{
          //   for (let index = 60; index < 80; index++) {

          //   }
          // }
          that.event = msg.event;
          let container =
            document.querySelector(".rowy") || document.querySelector(".main");
          setTimeout(() => {
            container.scrollTop = container.scrollHeight;
          });
          if (msg.event != "add") {
            if (msg.data) {
              that.prompt.push({
                role: "assistant",
                content:  msg.data,
              });
              audio(msg.data, "zh-CN-YunxiaNeural").then((res) => {
                if (res.resultData.data.playtime_seconds <= 0) {
                  that.flag = false;
                  that.videoSrc = res.resultData.data.url2;
                  return;
                }
                that.isShow = false;
                console.log(res, 6999);
                that.flag = false;
                that.playTimers = setInterval(() => {
                  if (that.playsFlag) {//一定会进入
                    clearInterval(that.playTimers);
                    that.signSucc = that.audioObj;
                    that.signSucc.src = res.resultData.data.url2;
                    console.log("##", "audio播放器更换URL", that.signSucc.src);

                    if (!that.signSucc.src) return;
                    that.plays = that.signSucc.play();
                    // that.$set(that,'videoSrcs',res.resultData.data.url3)
                    // that.curIndex=0;
                    // that.playVideoTag=true; // 当前播放的 ref 是否为 video
                    // that.canPlayNext=true;   // 是否存在下一个播放地址
                    that.playVideo(res.resultData.data.url3);
                    that.$refs.videoBox.style.zIndex = "99";
                    that.videos = true;
                    console.log("##", "video播放器更换URL", that.videoSrc);
                    console.log(that.signSucc, that.plays, "that.signSucc");

                    that.signSucc.addEventListener(
                      "ended",
                      function () {
                        that.videos = false;
                        console.log("audio结束", that.$refs.videoBox);
                        that.videoSrc = video;
                        // that.videoSrcs = [video2];
                        that.$refs.videoBox.style.zIndex = "-1";
                        that.$nextTick(() => {
                          that.$refs.video.src = "";
                          that.$refs.video1.src = "";
                        });
                      },
                      false
                    );
                  }
                }, 1000);
              });
            }
          }
        },
        onclose() {},
        onerror(err) {
          console.log("error", err);
        },
      });
    },
  },
};
